import type { VoidFunctionComponent } from 'react';

import Card from '../../../generic/Card/Card';
import type { GroupedTerms } from '../types';

import TermSection from './TermSection';

import styles from '../LicenseDrawer.module.less';

type Props = {
  summaryText: string;
  groupedTerms: GroupedTerms;
};

const SummaryTab: VoidFunctionComponent<Props> = ({ summaryText, groupedTerms }) => {
  return (
    <>
      <div className={styles.title}>
        Summary
      </div>
      <div className={styles.summary}>
        <div>
          {summaryText}
        </div>
        <div className={styles.disclaimerContainer}>
          <Card variant="fill" padding="small" isFullWidth>
            <Card.Content>
              This summary is provided for convenience. This is not legal advice.
            </Card.Content>
          </Card>
        </div>
        <TermSection title="You Can" icon="checkCircleO" terms={groupedTerms.CAN} />
        <TermSection title="You Cannot" icon="banOutline" terms={groupedTerms.CANNOT} />
      </div>
    </>
  );
};

export default SummaryTab;
